module.exports = __webpack_public_path__ + "img/Wish.cdd7c77b.jpg";